<template>
  <div>
    <div v-if="question.radio_button === true" class="q-radio-container main-color">
      <div v-if="question.trivia === true">
        <label class="trivia-question-content q-label" v-html="question.q"></label>
      </div>
      <div v-else>
        <label v-html="question.q"></label>
      </div>
      <div class="q-radio-answer">
        <md-radio v-model="answer" v-for="option in question.answers"  :key="option.value" :disabled="readOnly" @change="emitValueOptions" :value="option.value">{{ option.value }}</md-radio>
      </div>
    </div>
    <div v-else class="q-multiple-dropdown-container main-color">
      <label class="label-2cols q-label" v-html="question.q"></label>
      <md-field class="input-2cols">
        <v-select
            name="optionsAnswers"
            :multi="false"
            :options="arrayAnswers"
            label="label"
            v-model="answer"
            v-on:input="emitValueOptions"
            v-on:change="emitValueOptions">
          </v-select>
        
      </md-field>
    </div>
  </div>
</template>

<script>
export default {
  name: "options-question",
  props: {
    question: {
      type: Object,
      default: () => {
        return {};
      }
    },
    answerProp:{
      type: String,
      default: ""
    },
    readOnly:{
      type:Boolean,
      default: false
    },
    arrayAnswers: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  methods: {
    emitValueOptions: function() {
      this.$emit("emit-value", { "q_id": this.question.q_id, "q_type": this.question.q_type, "ans": this.answer });
    },
    getArrayAnswers: function() {
      this.arrayAnswers = [];
      for (var i in this.question.answers){
        this.arrayAnswers.push(this.question.answers[i].value);
      }
    },
    checkAnswer: function(){
      if(this.arrayAnswers.includes(this.answer) == false){
        alert('No contiene el texto');
      }

    }
  },
  mounted: function() {
    this.arrayAnswers = [];
    for (var i in this.question.answers){
      this.arrayAnswers.push(this.question.answers[i].value);
    }
  }
  ,
  data: function() {
    return {
      answer: this.answerProp
    };
  }
};
</script>

<style lang="scss" scoped>
  .md-radio {
    display: flex;
  }
</style>
